import css from "PFApp/activities/manage_roles/parts/cell.module.scss";
import { getRoleFormKeyPrefix } from "PFApp/components/activity_form/multi_activity_form/tabular_roles_form/tabular_roles_form.utils";
import { useManageRolesStore } from "PFApp/stores/manage_roles";
import { useTheme } from "PFApp/theme_context_provider/theme_context_provider_context";
import { FormSchemaField } from "PFApp/types/activity_form/activity_form_schema";
import { Id } from "PFCore/types";
import { PropsWithChildren } from "react";

type ManageRolesFieldCellProps = PropsWithChildren<{
  roleId: Id | undefined;
  field: FormSchemaField;
  additionalCellData?: Record<string, unknown>;
}>;

export const ManageRolesFieldCell = ({
  roleId,
  field,
  additionalCellData,
  children
}: ManageRolesFieldCellProps) => {
  const { themeVars } = useTheme();

  const hasFailed = useManageRolesStore((state) => {
    if (!roleId) {
      return false;
    }
    const prefixedKey = `${roleId}.${getRoleFormKeyPrefix(field)}${field.name}`;
    const rawKey = `${roleId}.${field.name}`;
    const edit = state.unsavedEdits[prefixedKey] ?? state.unsavedEdits[rawKey];
    return !!edit?.isError;
  });

  const ownBackgroundColor = hasFailed ? themeVars["paletteOrange2"] : undefined;

  const reservedBackgroundColor = additionalCellData?.backgroundColor as string | undefined;

  return (
    <div
      className={css.cellWrapper}
      style={{ backgroundColor: reservedBackgroundColor ?? ownBackgroundColor }}
    >
      {children}
    </div>
  );
};
